var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('LabeledInput',_vm._b({on:{"input":function($event){return _vm.update($event)}},model:{value:(_vm.userValue),callback:function ($$v) {_vm.userValue=$$v},expression:"userValue"}},'LabeledInput',_vm.$attrs,false))}
var staticRenderFns = []

export { render, staticRenderFns }